import React from 'react'

interface SherpaLogoProps {
  width?: string | number
  height?: string | number
  className?: string
}

export const SherpaLogo: React.FC<SherpaLogoProps> = ({
  width = 80,
  height = 80,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 80 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M39.9998 0C40.7103 0 41.3677 0.376903 41.7264 0.990234L54.5935 23H77.9998C78.7162 23 79.3776 23.3834 79.7342 24.0049C80.0907 24.6263 80.0879 25.3912 79.7263 26.0098L68.0388 46L79.7263 65.9902C80.0879 66.6088 80.0907 67.3737 79.7342 67.9951C79.3776 68.6166 78.7162 69 77.9998 69H54.5935L41.7264 91.0098C41.3677 91.6231 40.7103 92 39.9998 92C39.2893 92 38.6319 91.6231 38.2732 91.0098L25.406 69H1.99979C1.28333 69 0.621969 68.6166 0.265415 67.9951C-0.0911348 67.3737 -0.0883737 66.6088 0.273227 65.9902L11.9598 46L0.273227 26.0098C-0.0883737 25.3912 -0.0911348 24.6263 0.265415 24.0049C0.621969 23.3834 1.28333 23 1.99979 23H25.406L38.2732 0.990234L38.3435 0.87793C38.7139 0.331077 39.3336 2.05864e-08 39.9998 0ZM37.9998 82.6152V69H30.0398L37.9998 82.6152ZM41.9998 82.6152L49.9598 69H41.9998V82.6152ZM56.9324 65H70.2459L60.1824 59.4385L56.9324 65ZM41.9998 65H52.2986L56.6795 57.5029L41.9998 49.3896V65ZM23.3191 57.5029L27.701 65H37.9998V49.3896L23.3191 57.5029ZM9.7537 65H23.0672L19.8162 59.4385L9.7537 65ZM7.3953 61.7324L17.7976 55.9844L14.2762 49.9629L7.3953 61.7324ZM62.201 55.9844L72.6033 61.7324L65.7224 49.9629L62.201 55.9844ZM16.5935 46L21.2996 54.0488L35.865 46L21.2996 37.9502L16.5935 46ZM44.1336 46L58.699 54.0488L63.4051 46L58.699 37.9502L44.1336 46ZM23.3191 34.4961L37.9998 42.6094V27H27.701L23.3191 34.4961ZM41.9998 42.6094L56.6795 34.4961L52.2986 27H41.9998V42.6094ZM14.2762 42.0361L17.7976 36.0146L7.3953 30.2666L14.2762 42.0361ZM62.201 36.0146L65.7224 42.0361L72.6033 30.2666L62.201 36.0146ZM19.8162 32.5605L23.0672 27H9.7537L19.8162 32.5605ZM60.1824 32.5605L70.2459 27H56.9324L60.1824 32.5605ZM41.9998 23H49.9598L41.9998 9.38379V23ZM30.0398 23H37.9998V9.38379L30.0398 23Z" fill="url(#paint0_linear_6870_176914)"/>
      <defs>
        <linearGradient id="paint0_linear_6870_176914" x1="26.3257" y1="-2.23708" x2="103.161" y2="73.9571" gradientUnits="userSpaceOnUse">
          <stop stopColor="#71428B"/>
          <stop offset="1" stopColor="#6881A7"/>
        </linearGradient>
      </defs>
    </svg>
  )
}
